import React, { useCallback, useEffect, useState } from "react";
import debounce from "../../utils/debounce";

export default function () {
  const [coords, setCoords] = useState({
    prevY: pageYOffset,
    difY: 0,
  });

  const scrollHandler = useCallback(
    debounce((e) => {
      setCoords((prevState) => ({
        difY: pageYOffset - prevState.prevY,
        prevY: pageYOffset,
      }));
    }, 50),
    []
  );

  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);

    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  return coords;
}
